/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import Component from './lui-button'
import globalCss from 'lui-button.global.scss'
import Group from './lui-button-group'
import groupCss from 'lui-button-group.global.scss'

window.lui.registerComponent(Component, globalCss)
window.lui.registerComponent(Group, groupCss)



//////////////////
// WEBPACK FOOTER
// ./packages/lui-button/index.js
// module id = 177
// module chunks = 0 1 18